<template>
  <div v-if="notifications">
    <h2 class="text-2xs text-grey-darkest leading-none p-3 border-b-1 border-grey">
      {{ $t('Notifications') }}
    </h2>
    <ul v-if="notifications && notifications.length" class="notifications h-88 overflow-y-scroll">
      <li
        v-for="item in notifications"
        :key="item.id"
        class="border-b-1 border-grey cursor-pointer px-5 py-4 flex items-center justify-between bg-white"
      >
        <div>
          <p class="text-grey-darkest text-xs leading-normal mb-1">
            {{ item.message }}
          </p>
          <p class="text-grey-dark text-2xs leadin-tight">
            {{ $parseDate(item.updated_at) }}
          </p>
        </div>
        <indicator-module indicatorClass="bg-orange-dark h-6px w-6px" />
      </li>
    </ul>
    <div v-else class="px-5 py-4">
      {{ $t('No notifications') }}
    </div>
  </div>
</template>

<script>
import IndicatorModule from '@/components/shared/IndicatorModule'
import generalService from '@/services/general.service'
import { useGeneralStore } from '@/stores/general'

export default {
  name: 'NotificationPanel',
  components: {
    IndicatorModule
  },

  setup () {
    const generalStore = useGeneralStore()

    return {
      generalStore
    }
  },

  computed: {
    notifications () {
      return this.generalStore.notifications
    }
  },

  methods: {
    setNotifications (notifications) {
      this.generalStore.setNotifications(notifications)
    },
    getNotifications () {
      return this.generalStore.getNotifications()
    }
  },

  beforeUnmount () {
    if (this.notifications && this.notifications.length > 0) {
      generalService.setViewedNotifications()
      this.setNotifications([])
    }
  }
}
</script>

<style scoped>
.dropdown {
  right: -8px;
}
.dropdown::after {
  border-color: transparent transparent #ededed transparent;
}
.notifications li:last-child {
  border-bottom: none;
}
</style>
